$(document).ready(function() {


/*  if($('#country').length){
        $('#country').on('change',function(){
            var tval = $(this).val();

            if(tval == 'RU'){
                $('#delivery_37').prop("checked", true);
                $('#delivery_37').parent().show();
                $('#delivery_34').parent().hide();
            }else{
                $('#delivery_34').prop("checked", true);
                $('#delivery_34').parent().show();
                $('#delivery_37').parent().hide();
            }
            

        });
    }*/





/*-------change country events*/
/*    $('.currency').on('click',function(){
        $('.currency').removeClass('active');
        $(this).addClass('active');

        var contr = $(this).data('country');
        localStorage.setItem("contr", contr);

        window.location.reload();
    });



    if(!localStorage.getItem("contr")){
        localStorage.setItem("contr", "rus");
    }
    if(localStorage.getItem("contr") == "rus"){
        localStorage.getItem("contr");
        $('.currency').removeClass('active');
        $('.currency').eq(0).addClass('active');
    }
    if(localStorage.getItem("contr") == "world"){
        localStorage.getItem("contr");
        $('.currency').removeClass('active');
        $('.currency').eq(1).addClass('active');


        var thisId;
        $('.mon').text('$');
        $('.ms2_form').each(function(){

            thisId = $(this).find('input[name=\"id\"]').val();

            if(thisId =='31'){
                
                
                $(this).find('.num').text('40');
            }
            if(thisId =='30'){
                
                $(this).find('.num').text('60');
            }
            if(thisId =='13'){
                $(this).find('.num').text('95');
                
            }
        });



    }

    $('.product_card__button').on('click',function(){
        if(localStorage.getItem("contr") == "world"){
            window.location.replace('https://adedmoscow.com/pre-order');
            return false;
        }
    });*/
/*------/change country events*/

/*-----minishop change count of product*/
    $('.minus').on('click', function() {
        var numb = parseInt($(this).parent().find('.count').val());
        if (numb > 1) {
            $(this).parent().find('.count').val(--numb);
            $(this).parent().find('.card__body__checkout__item__footer__input').trigger('change');
        }

    });
    $('.plus').on('click', function() {
        var numb = parseInt($(this).parent().find('.count').val());
        $(this).parent().find('.count').val(++numb);
        $(this).parent().find('.card__body__checkout__item__footer__input').trigger('change');
    });
/*----/minishop change count of product*/

    $('#show_content').on('mouseover', function(e) {

        if (!$(this).hasClass('active')) {
            setTimeout(function() {
                $('.to-hide-main-page-wrap').addClass('hide');
                $('.to-hide-main-page-wrap').removeClass('progress');

                $('.hide-main-page-wrap').addClass('show');
                $('.hide-main-page-wrap').removeClass('progress');
            }, 0);
            $('.to-hide-main-page-wrap').addClass('progress');
            $(this).addClass('active');
        }


    });

/*
    $('#product-slider').slick({
        arrows: false,
        adaptiveHeight: true,
        dots: true,
        appendDots: $('#dots-block')
    });
  */
$('#product-slider').slick({
        arrows: false,
        adaptiveHeight: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        appendDots: $('#dots-block')
    });
    /*
        $('#subform').on('mouseleave', function(e) {
      
            if ($('#show_content').hasClass('active')) {
                setTimeout(function() {
                    $('.to-hide-main-page-wrap').removeClass('hide');
                   

                    $('.hide-main-page-wrap').removeClass('show');
                    $('.hide-main-page-wrap').removeClass('progress_hide');
                
                }, 0);
                
                $('.hide-main-page-wrap').addClass('progress_hide');
                $('#show_content').removeClass('active');
            }


        });*/





    $(".projects-list__wrap").niceScroll({
        cursoropacitymin: 1
    });

    new WOW({ scrollContainer: '.projects-list__wrap' }).init({});
    /*
        $('#slider1').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            infinite: false,
            arrows: false
        }).on("mousewheel", function(event) {
            event.preventDefault();
            if (event.deltaX > 0 || event.deltaY < 0) {
                $(this).slick('slickNext');
            } else if (event.deltaX < 0 || event.deltaY > 0) {
                $(this).slick('slickPrev');
            }
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            console.log(nextSlide);
            if (nextSlide >= 9) {
                if (!$('.news-menu__wrap').hasClass('active')) {
                    $('.news-menu__wrap').addClass('active');
                    $('.news-menu__wrap').fadeIn(500);
                }

            }
        });*/

    $('#slider1').on('scroll', function() {
        if ($('#slider1').scrollTop() >= $('#slider1 .slider-item').height() * ($('#slider1 .slider-item').length - 1.5)) {

            if (!$('.news-menu__wrap').hasClass('active')) {
                $('.news-menu__wrap').addClass('active');
                $('.news-menu__wrap').fadeIn(500);
            }

        }
    });


// some bg images in shop page for random watching
    jQuery.preloadImages = function(list) {
        for (var i = 0; i < list.length; i++) {
            jQuery("<img>").attr("src", list[i]);
        }
    };

    var numb = 0;
    (function (){
      if ($('.shop-bg').length) {
        if ($('.shop-bg').data('img').length) {
            var startImgListPreoload = $('.shop-bg').data('img').split(',').slice(0, 3);
            $.preloadImages(startImgListPreoload);
            var url = "url(\"" + startImgListPreoload[0] + "\")";
            $('.shop-bg').css("background-image", url);
        }

    }  


    })();
    
    
    $('.shop-content__block img').on('mouseover', function() {
        var img = $('.shop-bg').data('img').split(',');
        ++numb;
        if (numb > img.length - 1) {
            numb = 0;
        }

        $('.shop-content__block').removeClass('active');
        $(this).parents('.shop-content__block').addClass('active');

        var currImgListPreoload = img.slice(numb, numb + 3);
        $.preloadImages(currImgListPreoload);
        
        var currImg = img[numb];
        var url = "url(\"" + currImg + "\")";
        $('.shop-bg').css("background-image", url);
     });
// some bg images in shop page for random watching - end


    $('.ms2_form').find('.sizes_block_item').on('click', function() {
        $('.sizes_block_item').removeClass('active');
        $(this).addClass('active');
        var size = $(this).data('size');
        $(this).parents('.ms2_form').find('input[name=\"options[size]\"]').val(size);
    });






    $('#mobile-menu-trigger').on('click', function() {
        $('#mobile-menu-wrap').addClass('active');
    });
    $('#mobile-menu-close').on('click', function() {
        $('#mobile-menu-wrap').removeClass('active');
    });







});







